import { useEffect } from "react";
import styled from "styled-components";
import { Button, Col, Layout, Row, Divider, Typography } from "antd";
import { useAppDispatch } from "hooks/useAppDispatch";
import { setSider } from "store/app/appSlice";
import { AppLogo } from "components/AppLogo";
import { useAppSelector } from "hooks/useAppSelector";
import { AppUserInfoMenu } from "components/AppHeader/AppUserInfoMenu";
import { variables } from "common/variables";
import { useNavigate, useLocation } from "react-router-dom";

const { Header } = Layout;

const StyledHeader = styled(Header)`
  background-color: white;
  border-bottom: 1px solid #ebebeb;
  padding: 0 1.5rem;
  z-index: 9;
`;

const ContextButton = styled(Button)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: auto;
  padding: 4px 12px;
  line-height: 1.3;

  &.filterButton {
    &--active {
      border-color: ${variables.primaryColor} !important;
    }
  }
`;

const ContextLabel = styled(Typography.Text)`
  font-size: 11px;
  color: #888;
  line-height: 1;
`;

const ContextValue = styled(Typography.Text)`
  font-size: 13px;
  font-weight: 600;
  color: #222;
  line-height: 1.2;
`;

export const AppHeaderDesktop = () => {
  const dispatch = useAppDispatch();
  const { user, whId, whDivId, whDivisions } = useAppSelector((state) => state.app);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    dispatch(setSider(true));
  }, [dispatch]);

  const whName = user.user?.mappedWh?.find((e) => e.id === whId)?.name ?? `#${whId}`;
  const divName = whDivisions.find((d) => d.id === whDivId)?.name ?? (whDivId ? `Division #${whDivId}` : "—");

  const handleContextClick = () => {
    navigate("/warehouse-selection", { state: { from: location } });
  };

  return (
    <StyledHeader>
      <Row justify="space-between" align="middle">
        <Col>
          <AppLogo />
        </Col>
        {user?.isAuthenticated && (
          <>
            <Col style={{ display: "flex", alignItems: "center" }}>
              <ContextButton onClick={handleContextClick}>
                <ContextLabel>Warehouse</ContextLabel>
                <ContextValue>{whName}</ContextValue>
              </ContextButton>
              <Divider type="vertical" style={{ height: 28, margin: "0 4px" }} />
              <ContextButton onClick={handleContextClick}>
                <ContextLabel>Division</ContextLabel>
                <ContextValue>{divName}</ContextValue>
              </ContextButton>
            </Col>
            <Col style={{ marginLeft: ".5rem" }}>
              <AppUserInfoMenu />
            </Col>
          </>
        )}
      </Row>
    </StyledHeader>
  );
};
